/* tslint:disable */
/* eslint-disable */
/**
 * MNR API
 * CBM MNR Portal API documentation
 *
 * The version of the OpenAPI document: 1.4.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Attachment } from '../model';
// @ts-ignore
import { CreateAttachment } from '../model';
// @ts-ignore
import { CreateAttachmentExport } from '../model';
// @ts-ignore
import { Export } from '../model';
/**
 * AttachmentApi - axios parameter creator
 * @export
 */
export const AttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new attachment
         * @summary Create a pre signed post
         * @param {CreateAttachment} [createAttachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAttachmentCreate: async (createAttachment?: CreateAttachment, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/attachment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-60iocaong94h1jqn8500bje6sh required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-60iocaong94h1jqn8500bje6sh", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAttachment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new attachment export
         * @summary Create attachment export
         * @param {CreateAttachmentExport} [createAttachmentExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAttachmentExport: async (createAttachmentExport?: CreateAttachmentExport, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/attachment/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-60iocaong94h1jqn8500bje6sh required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-60iocaong94h1jqn8500bje6sh", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAttachmentExport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentApi - functional programming interface
 * @export
 */
export const AttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new attachment
         * @summary Create a pre signed post
         * @param {CreateAttachment} [createAttachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAttachmentCreate(createAttachment?: CreateAttachment, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAttachmentCreate(createAttachment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new attachment export
         * @summary Create attachment export
         * @param {CreateAttachmentExport} [createAttachmentExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAttachmentExport(createAttachmentExport?: CreateAttachmentExport, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Export>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAttachmentExport(createAttachmentExport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AttachmentApi - factory interface
 * @export
 */
export const AttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentApiFp(configuration)
    return {
        /**
         * Creates a new attachment
         * @summary Create a pre signed post
         * @param {CreateAttachment} [createAttachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAttachmentCreate(createAttachment?: CreateAttachment, options?: any): AxiosPromise<Attachment> {
            return localVarFp.postAttachmentCreate(createAttachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new attachment export
         * @summary Create attachment export
         * @param {CreateAttachmentExport} [createAttachmentExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAttachmentExport(createAttachmentExport?: CreateAttachmentExport, options?: any): AxiosPromise<Export> {
            return localVarFp.postAttachmentExport(createAttachmentExport, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentApi - object-oriented interface
 * @export
 * @class AttachmentApi
 * @extends {BaseAPI}
 */
export class AttachmentApi extends BaseAPI {
    /**
     * Creates a new attachment
     * @summary Create a pre signed post
     * @param {CreateAttachment} [createAttachment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public postAttachmentCreate(createAttachment?: CreateAttachment, options?: any) {
        return AttachmentApiFp(this.configuration).postAttachmentCreate(createAttachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new attachment export
     * @summary Create attachment export
     * @param {CreateAttachmentExport} [createAttachmentExport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public postAttachmentExport(createAttachmentExport?: CreateAttachmentExport, options?: any) {
        return AttachmentApiFp(this.configuration).postAttachmentExport(createAttachmentExport, options).then((request) => request(this.axios, this.basePath));
    }
}
